import React from "react";
import "../styles/contact.css";
import { Link } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core/styles.css";
library.add(fab);

const ContactUs = () => {
  return (
    <>
      <div className="contact_container">
        <div className="contact_data">
          <h1>This project is developed by Soumyajit Pan</h1>
        </div>
        <div className="icon_container">
          <div className="contact_icon contact_data">
            <Link
              to="https://www.linkedin.com/in/soumyajit-pan-29-som/"
              target="_blank"
            >
              <FontAwesomeIcon icon={["fab", "linkedin"]} />
            </Link>
          </div>
          <div className="contact_icon contact_data">
            <Link to="https://twitter.com/ErSoumyajit" target="_blank">
              <FontAwesomeIcon icon={["fab", "twitter"]} />
            </Link>
          </div>
          <div className="contact_icon contact_data">
            <Link to="https://telegram.me/captain_stark_29" target="_blank">
              <FontAwesomeIcon icon={["fab", "telegram"]} />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
